{
  "name": "mono-unis",
  "description": "mono-unis",
  "productName": "mono-unis",
  "version": "1.59.6",
  "utDpuVersion": "2.1.0+299.233837",
  "utScanPlanVersion": "6.8.0-Alpha.403",
  "unisBridgeVersion": "0.0.0",
  "engines": {
    "node": "22.21.1"
  },
  "scripts": {
    "build-license": "node ./tools/license-check/license.updater.js",
    "license-report": "license-checker --production --csv --out ./licenses.csv",
    "prepare": "husky install",
    "fetch-ace-presets-files": "node ./tools/ace/fetch-presets-files.js",
    "install-python-deps": "node ./tools/install-python-deps.js",
    "postinstall": "npm run install-python-deps && node ./tools/dpu/dpu.updater.js ut && node ./tools/dpu/dpu.updater.js ec && node ./tools/scanplan/scanplan.downloader.js && npm run fetch-ace-presets-files && node ./tools/install-playwright/install-playwright.js && node ./tools/unisbridge/unisbridge.updater.js && npm run ut-device:e2e:download-files",
    "clean-repo": "python ./tools/maintenance/cleanup_environment.py",
    "//windview-app": "echo Windview App",
    "windview:start": "npm run windview:launch-dpu && nx run windview:serve",
    "windview:start:sim": "npm run windview:launch-dpu -- --simulator-count 1 && nx run windview:serve",
    "windview:launch-dpu": "node ./tools/launchers/launch-dpu.js Ut",
    "windview:launch-dpu:sim": "node ./tools/launchers/launch-dpu.js Ut --simulator-count 1 --simulator-mode m1",
    "windview:electron:dev:build": "rimraf ./electron/windview/dist && nx run windview:build --configuration electron",
    "windview:electron:dev:package": "python ./electron/electron-package-builder.py --product-name windview --target pc --environment dev",
    "aeroview:electron:dev:package": "python ./electron/electron-package-builder.py --product-name aeroview --target pc --environment dev",
    "oneutview:electron:dev:package": "python ./electron/electron-package-builder.py --product-name oneutview --target pc --environment dev",
    "windview:electron:dev:installer:build": "npm run windview:electron:dev:build && npm run windview:electron:dev:package && npm run aeroview:electron:dev:package && npm run oneutview:electron:dev:package && powershell -Command \"Set-Location ./packages/windview; ./advanced_installer_entrypoint.ps1 0.0.1 dev\"",
    "windview:electron:prod:build": "rimraf ./electron/windview/dist && nx run windview:build --configuration electron-prod",
    "windview:electron:prod:package": "python ./electron/electron-package-builder.py --product-name windview --target pc --environment prod",
    "aeroview:electron:prod:package": "python ./electron/electron-package-builder.py --product-name aeroview --target pc --environment prod",
    "oneutview:electron:prod:package": "python ./electron/electron-package-builder.py --product-name oneutview --target pc --environment prod",
    "windview:electron:prod:installer:build": "npm run windview:electron:prod:build && npm run windview:electron:prod:package && npm run aeroview:electron:prod:package && npm run oneutview:electron:prod:package && powershell -Command \"Set-Location ./packages/windview; ./advanced_installer_entrypoint.ps1 0.0.1\"",
    "//ut-device": "echo UT Device App",
    "ut-device:scanplan": "node ./tools/scanplan/scanplan.downloader.js",
    "ut-device:e2e:download-files": "node ./tools/e2e/nde-files.downloader.js",
    "ut-device:launch-scanplan": "node ./tools/launchers/launch-scanplan.js",
    "//medusa": "echo Medusa/Epoch700 App ",
    "medusa:electron:dev:build": "rimraf ./electron/medusa/dist && nx run ut-device:build:electron",
    "medusa:electron:dev:package:epoch:pc": "python ./electron/electron-package-builder.py --product-name epoch_700 --target pc --environment dev",
    "medusa:electron:dev:package:epoch:device": "python ./electron/electron-package-builder.py --product-name epoch_700 --target device --environment dev",
    "medusa:electron:dev:build:package:epoch:pc": "npm run medusa:electron:dev:build && npm run medusa:electron:dev:package:epoch:pc",
    "medusa:electron:dev:build:package:epoch:device": "npm run medusa:electron:dev:build && npm run medusa:electron:dev:package:epoch:device",
    "medusa:electron:prod:build": "rimraf ./electron/medusa/dist && nx run ut-device:build:electron-prod",
    "medusa:electron:prod:package:epoch:pc": "python ./electron/electron-package-builder.py --product-name epoch_700 --target pc --environment prod",
    "medusa:electron:prod:package:epoch:device": "python ./electron/electron-package-builder.py --product-name epoch_700 --target device --environment prod",
    "medusa:electron:prod:build:package:epoch:pc": "npm run medusa:electron:prod:build && npm run medusa:electron:prod:package:epoch:pc",
    "medusa:electron:prod:build:package:epoch:device": "npm run medusa:electron:prod:build && npm run medusa:electron:prod:package:epoch:device",
    "medusa:launch-dpu": "node ./tools/launchers/launch-dpu.js Ut --simulator-count 1 --simulator-mode m2 --setups packages/ut-device/src/assets/medusa/setups",
    "medusa:start:sim": "npm run medusa:launch-dpu && nx run ut-device:serve:development",
    "//thickness": "echo Thickness App",
    "thickness:electron:build:thickness": "rimraf ./electron/thickness/dist && nx run ut-device:build:electronThickness",
    "thickness:electron:package:ut-live:pc": "python ./electron/electron-package-builder.py --product-name UT_Live --target pc --environment dev",
    "thickness:electron:package:ut-live:device": "python ./electron/electron-package-builder.py --product-name UT_Live --target device --environment dev",
    "thickness:electron:build:package:ut-live:pc": "npm run thickness:electron:build:thickness && npm run thickness:electron:package:ut-live:pc",
    "thickness:electron:build:package:ut-live:device": "npm run thickness:electron:build:thickness && npm run thickness:electron:package:ut-live:device",
    "thickness:launch-dpu": "node ./tools/launchers/launch-dpu.js Ut --simulator-count 1 --simulator-mode m2 --setups packages/ut-device/src/assets/thickness-gauge/setups",
    "thickness:start:sim": "npm run thickness:launch-dpu && nx run ut-device:serve:developmentThickness",
    "//atom-app": "echo Atom/Omniscan700 App",
    "atom:electron:build": "rimraf ./electron/atom/dist && nx run ut-device:build:electronAtom",
    "atom:electron:package:omniscan:pc": "python ./electron/electron-package-builder.py --product-name Omniscan700 --target pc --environment dev",
    "atom:electron:package:omniscan:device": "python ./electron/electron-package-builder.py --product-name Omniscan700 --target device --environment dev",
    "atom:electron:build:package:omniscan:pc": "npm run atom:electron:build && npm run atom:electron:package:omniscan:pc",
    "atom:electron:build:package:omniscan:device": "npm run atom:electron:build && npm run atom:electron:package:omniscan:device",
    "atom:launch-dpu": "node ./tools/launchers/launch-dpu.js Ut --simulator-count 1 --simulator-mode m2 --setups packages/ut-device/src/assets/atom/setups",
    "atom:start:sim": "npm run atom:launch-dpu && nx run ut-device:serve:developmentAtom",
    "//ec-device-app": "echo EC-Device App",
    "ec-device:electron:dev:build": "rimraf ./electron/ec-device/dist && nx run ec-device:build:electron",
    "ec-device:electron:dev:package:ace:pc": "python ./electron/electron-package-builder.py --product-name ace --target pc --environment dev",
    "ec-device:electron:dev:package:ace:device": "python ./electron/electron-package-builder.py --product-name ace --target device --environment dev",
    "ec-device:electron:dev:build:package:ace:pc": "npm run ec-device:electron:dev:build && npm run ec-device:electron:dev:package:ace:pc",
    "ec-device:electron:dev:build:package:ace:device": "npm run ec-device:electron:dev:build && npm run ec-device:electron:dev:package:ace:device",
    "ec-device:electron:prod:build": "rimraf ./electron/ec-device/dist && nx run ec-device:build:electron-prod",
    "ec-device:electron:prod:package:ace:pc": "python ./electron/electron-package-builder.py --product-name ace --target pc --environment prod",
    "ec-device:electron:prod:package:ace:device": "python ./electron/electron-package-builder.py --product-name ace --target device --environment prod",
    "ec-device:electron:prod:build:package:ace:pc": "npm run ec-device:electron:prod:build && npm run ec-device:electron:prod:package:ace:pc",
    "ec-device:electron:prod:build:package:ace:device": "npm run ec-device:electron:prod:build && npm run ec-device:electron:prod:package:ace:device",
    "ec-device:electron:dev:package:ace-port-pc": "python ./electron/electron-package-builder.py --product-name ace-port-pc --target pc --environment dev",
    "ec-device:electron:dev:build:package:ace-port-pc": "npm run ec-device:electron:dev:build && npm run ec-device:electron:dev:package:ace-port-pc",
    "ec-device:electron:prod:package:ace-port-pc": "python ./electron/electron-package-builder.py --product-name ace-port-pc --target pc --environment prod",
    "ec-device:electron:prod:build:package:ace-port-pc": "npm run ec-device:electron:prod:build && npm run ec-device:electron:prod:package:ace-port-pc",
    "ec-device:launch-dpu": "node ./tools/launchers/launch-dpu.js Ec --deviceplayer --setups packages/ec-device/setups",
    "//ec-desktop-app": "echo EC-Desktop App",
    "ec-desktop:launch-dpu": "node ./tools/launchers/launch-dpu.js Ec",
    "ec-desktop:electron:dev:build": "rimraf ./electron/ec-desktop/dist && nx run ec-desktop:build:electron --skipNxCache",
    "ec-desktop:electron:dev:package": "python ./electron/electron-package-builder.py --product-name ec-desktop --target pc --environment dev",
    "ec-desktop:electron:dev:build:package": "npm run ec-desktop:electron:dev:build && npm run ec-desktop:electron:dev:package",
    "ec-desktop:electron:prod:build": "rimraf ./electron/ec-desktop/dist && nx run ec-desktop:build:electron-prod",
    "ec-desktop:electron:prod:package": "python ./electron/electron-package-builder.py --product-name ec-desktop --target pc --environment prod",
    "ec-desktop:electron:prod:build:package": "npm run ec-desktop:electron:prod:build && npm run ec-desktop:electron:prod:package",
    "//system-control-app": "echo System Control App",
    "system-control-view:electron:package:system-control:pc": "nx run system-control-view:build:electron && python ./electron/electron-package-builder.py --product-name system-control --target pc --environment dev",
    "system-control-view:electron:package:system-control:linuxArm64Device": "nx run system-control-view:build:electron && python ./electron/electron-package-builder.py --product-name system-control --target linuxArm64Device --environment dev",
    "system-control-view:electron:package:system-control:linuxX64Device": "nx run system-control-view:build:electron && python ./electron/electron-package-builder.py --product-name system-control --target linuxX64Device --environment dev",
    "system-control-view:electron:start": "nx run system-control-view:build:electron && python ./electron/electron-package-builder.py --product-name system-control --target pc --environment dev --mode run",
    "system-control-view:electron:start:devtools": "nx run system-control-view:build:electron && python ./electron/electron-package-builder.py --product-name system-control --target pc --environment dev --mode run-with-tools",
    "//translations": "echo Translations",
    "desktop-file-browser:export-translations": "node ./tools/translation-extractor/export-translations.js --folder packages/shared-business-angular/src/lib/desktop-file-browser/assets/i18n --notes ./tools/translation-extractor/notes/desktop-file-browser.notes.js --supported-lang fr --xls-name desktop-file-browser-translations",
    "desktop-file-browser:import-translations": "node ./tools/translation-extractor/import-translations.js --file desktop-file-browser-translations.xlsx --folder packages/shared-business-angular/src/lib/desktop-file-browser/assets/i18n",
    "tiling-canvas:export-translations": "node ./tools/translation-extractor/export-translations.js --folder packages/shared-business-angular/src/lib/tiling-canvas/assets/i18n --notes ./tools/translation-extractor/notes/tiling-canvas.notes.js --supported-lang fr --xls-name tiling-canvas-translations",
    "tiling-canvas:import-translations": "node ./tools/translation-extractor/import-translations.js --file tiling-canvas-translations.xlsx --folder packages/shared-business-angular/src/lib/tiling-canvas/assets/i18n",
    "file-manager:export-translations": "node ./tools/translation-extractor/export-translations.js --folder packages/shared-modules-angular/src/lib/file-manager/assets/i18n --notes ./tools/translation-extractor/notes/file-manager.notes.js --supported-lang ar,cs,de,es,fr,hi,hu,id,it,ja,ko,ms,nl,nb,pl,pt,ru,sv,tr,zh --xls-name file-manager-translations",
    "file-manager:import-translations": "node ./tools/translation-extractor/import-translations.js --file file-manager-translations.xlsx --folder packages/shared-modules-angular/src/lib/file-manager/assets/i18n",
    "ec-device:export-translations": "node ./tools/translation-extractor/export-translations.js --folder packages/ec-device/src/assets/i18n --notes ./tools/translation-extractor/notes/ec-device.notes.js --supported-lang ar,cs,de,es,fr,hi,hu,id,it,ja,ko,ms,nl,nb,pl,pt,ru,sv,tr,zh",
    "ec-device:import-translations": "node ./tools/translation-extractor/import-translations.js --file translations.xlsx --folder packages/ec-device/src/assets/i18n",
    "ec-desktop:export-translations": "node ./tools/translation-extractor/export-translations.js --folder packages/ec-desktop/src/assets/i18n --notes ./tools/translation-extractor/notes/ec-desktop.notes.js --supported-lang fr",
    "ec-desktop:import-translations": "node ./tools/translation-extractor/import-translations.js --file translations.xlsx --folder packages/ec-desktop/src/assets/i18n",
    "system-control:export-translations": "node ./tools/translation-extractor/export-translations.js --folder packages/shared-modules-angular/src/lib/system-control/assets/i18n --notes ./tools/translation-extractor/notes/system-control.notes.js --supported-lang ar,cs,de,es,fr,hi,hu,id,it,ja,ko,ms,nl,nb,pl,pt,ru,sv,tr,zh --xls-name system-control-translations",
    "system-control:import-translations": "node ./tools/translation-extractor/import-translations.js --file system-control-translations.xlsx --folder packages/shared-modules-angular/src/lib/system-control/assets/i18n"
  },
  "author": "Evident Scientific",
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.23",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.23",
    "@angular/compiler": "21.2.23",
    "@angular/core": "21.2.23",
    "@angular/forms": "21.2.23",
    "@angular/platform-browser": "21.2.23",
    "@angular/platform-browser-dynamic": "21.2.23",
    "@angular/router": "21.2.23",
    "@azure/msal-angular": "4.1.1",
    "@azure/msal-browser": "4.30.0",
    "@evc/platform": "2.3.2",
    "@evc/web-components": "2.3.5",
    "@microsoft/signalr": "7.0.14",
    "@ngrx/effects": "21.0.0",
    "@ngrx/operators": "21.0.0",
    "@ngrx/store": "21.0.0",
    "@ngrx/store-devtools": "21.0.0",
    "@ngx-translate/core": "17.0.0",
    "@ngx-translate/http-loader": "17.0.0",
    "file-saver": "2.0.5",
    "gridstack": "7.2.0",
    "jspdf": "4.2.1",
    "jspdf-autotable": "5.0.7",
    "konva": "8.4.0",
    "lodash.clonedeep": "4.5.0",
    "lodash.isequal": "4.5.0",
    "luxon": "3.7.2",
    "marked": "15.0.12",
    "ng-resize-observer": "1.2.0",
    "ngx-cookie": "6.0.1",
    "rxjs": "7.8.2",
    "simple-keyboard": "3.8.93",
    "tslib": "2.8.1",
    "zone.js": "0.16.2",
    "html-to-image": "1.11.13"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "21.2.24",
    "@angular-devkit/core": "21.2.24",
    "@angular-devkit/schematics": "21.2.24",
    "@angular-eslint/eslint-plugin": "21.2.0",
    "@angular-eslint/eslint-plugin-template": "21.2.0",
    "@angular-eslint/template-parser": "21.2.0",
    "@angular/build": "21.2.24",
    "@angular/cli": "21.2.24",
    "@angular/compiler-cli": "21.2.23",
    "@angular/language-service": "21.2.23",
    "@apidevtools/json-schema-ref-parser": "11.9.3",
    "@e965/xlsx": "0.20.3",
    "@eslint/js": "9.39.3",
    "@ngneat/spectator": "22.1.0",
    "@ngrx/eslint-plugin": "21.0.0",
    "@nx/angular": "23.2.1",
    "@nx/eslint": "23.2.1",
    "@nx/eslint-plugin": "23.2.1",
    "@nx/jest": "23.2.1",
    "@nx/js": "23.2.1",
    "@nx/playwright": "23.2.1",
    "@nx/storybook": "23.2.1",
    "@nx/web": "23.2.1",
    "@nx/workspace": "23.2.1",
    "@playwright/test": "1.64.1",
    "@schematics/angular": "21.2.9",
    "@storybook/addon-docs": "10.4.3",
    "@storybook/angular": "10.4.3",
    "@stylistic/eslint-plugin": "5.6.1",
    "@swc-node/register": "1.11.1",
    "@swc/core": "1.15.8",
    "@swc/helpers": "0.5.18",
    "@testing-library/angular": "18.1.1",
    "@testing-library/dom": "10.4.1",
    "@testing-library/jest-dom": "6.9.1",
    "@types/file-saver": "2.0.5",
    "@types/fs-extra": "11.0.4",
    "@types/glob": "8.1.0",
    "@types/jest": "30.0.0",
    "@types/jest-when": "3.5.5",
    "@types/json-schema-merge-allof": "0.6.5",
    "@types/lodash.clonedeep": "4.5.9",
    "@types/lodash.isequal": "4.5.8",
    "@types/luxon": "3.7.1",
    "@types/madge": "5.0.3",
    "@types/node": "22.9.3",
    "@typescript-eslint/eslint-plugin": "8.56.0",
    "@typescript-eslint/parser": "8.56.0",
    "autoprefixer": "10.4.21",
    "camelcase-keys": "7.0.2",
    "canvas": "3.2.0",
    "commander": "11.1.0",
    "dotenv": "17.4.2",
    "eslint": "9.39.3",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-jest": "29.15.0",
    "eslint-plugin-local-rules": "3.0.2",
    "eslint-plugin-playwright": "2.4.0",
    "eslint-plugin-rxjs-x": "0.8.4",
    "eslint-plugin-simple-import-sort": "12.1.1",
    "extract-zip": "2.0.1",
    "find-cache-dir": "3.3.2",
    "find-process": "1.4.7",
    "fs-extra": "11.3.0",
    "globals": "16.5.0",
    "husky": "8.0.3",
    "jest": "30.4.2",
    "jest-environment-jsdom": "30.4.1",
    "jest-expect-message": "1.1.3",
    "jest-junit": "17.0.0",
    "jest-marbles": "3.1.1",
    "jest-preset-angular": "16.1.5",
    "jest-webgl-canvas-mock": "2.5.3",
    "jest-when": "3.7.0",
    "json-schema-merge-allof": "0.8.1",
    "json-schema-to-typescript": "15.0.4",
    "license-checker": "25.0.1",
    "lodash.merge": "4.6.2",
    "madge": "7.0.0",
    "ng-mocks": "14.15.2",
    "ng-packagr": "21.2.3",
    "ngx-spinner": "16.0.2",
    "nx": "23.2.1",
    "nx-stylelint": "18.0.2",
    "picocolors": "1.1.1",
    "replace-in-file": "6.3.5",
    "rimraf": "6.1.3",
    "snakecase-keys": "8.1.0",
    "storybook": "10.4.3",
    "storybook-addon-pseudo-states": "10.4.3",
    "stylelint": "16.26.1",
    "stylelint-config-idiomatic-order": "10.0.0",
    "stylelint-config-standard": "39.0.1",
    "stylelint-config-standard-scss": "16.0.0",
    "svg-sprite": "2.0.4",
    "ts-jest": "29.4.11",
    "ts-jest-mock-import-meta": "1.3.2",
    "ts-json-schema-generator": "2.5.0",
    "ts-node": "10.9.2",
    "type-fest": "4.41.0",
    "typescript": "5.9.3",
    "typescript-eslint": "8.56.0",
    "typescript-strict-plugin": "2.4.4",
    "zeromq": "6.5.0",
    "zod": "3.25.32"
  },
  "workspaces": [
    "packages/*"
  ]
}
